import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-876dd8b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header l-header" }
const _hoisted_2 = { class: "c-site-header" }
const _hoisted_3 = {
  href: "/",
  class: "u-d-block"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "c-search-window"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-search" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "u-sr" }, "検索", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "c-cates-open"
}
const _hoisted_10 = ["aria-expanded"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "u-d-iblock" }, "カテゴリ・タグから探す", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "c-gnav"
}
const _hoisted_14 = { class: "c-gmenu" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "34",
  height: "34"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-bookmark" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "u-sr" }, "ブックマーク", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "34",
  height: "34"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-bell" })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "u-sr" }, "お知らせ", -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "34",
  height: "34"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-gear" })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "u-sr" }, "管理画面", -1))
const _hoisted_22 = ["aria-hidden"]
const _hoisted_23 = { class: "c-modal__header" }
const _hoisted_24 = { class: "c-modal__header-inner" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "c-modal__title" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "26",
    height: "26"
  }, [
    /*#__PURE__*/_createElementVNode("use", { href: "#icon-search" })
  ]),
  /*#__PURE__*/_createTextVNode("カテゴリ・タグから探す")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-close" })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "c-modal__body" }
const _hoisted_29 = { class: "c-modal__sec" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "c-modal__stitle" }, "カテゴリから探す", -1))
const _hoisted_31 = { class: "c-modal__links" }
const _hoisted_32 = { class: "c-modal__sec" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "c-modal__stitle" }, "階層から探す", -1))
const _hoisted_34 = { class: "c-modal__links" }
const _hoisted_35 = { class: "c-modal__sec" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "c-modal__stitle" }, "タグから探す", -1))
const _hoisted_37 = { class: "c-modal__links" }
const _hoisted_38 = { class: "c-modal__footer" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-close" })
], -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode("閉じる")
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  key: 1,
  class: "header p-page-header"
}
const _hoisted_43 = { class: "c-page-title" }
const _hoisted_44 = ["src"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "c-exp" }, [
  /*#__PURE__*/_createTextVNode("ご利用いただきありがとうございます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("下記よりログインしてご利用ください。")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.loggedIn)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass({'c-logo': true, 'is-visible': _ctx.logoVisible})
            }, [
              _createElementVNode("a", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.logo('pc'),
                  alt: "Video Library"
                }, null, 8, _hoisted_4)
              ])
            ], 2),
            (_ctx.loggedIn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("form", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "search",
                      class: "c-search-window__kw",
                      placeholder: "キーワードから講座を検索",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.keyword]
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "c-search-window__btn",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)), ["prevent"]))
                    }, _hoisted_8)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.loggedIn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "j-open-modal-cates",
                    "data-toggle": "modal",
                    "aria-controls": "j-modal-cates",
                    "aria-expanded": _ctx.modalExpanded,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
                  }, _hoisted_12, 8, _hoisted_10)
                ]))
              : _createCommentVNode("", true),
            (_ctx.loggedIn)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_13, [
                  _createElementVNode("ul", _hoisted_14, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { path: '/bookmark' } }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _hoisted_16
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: { path: '/news' },
                        class: _normalizeClass({'is-attention': _ctx.newsArrival })
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _hoisted_18
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    (_ctx.isCorpAdmin)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                          _createVNode(_component_router_link, { to: { path: '/a/' } }, {
                            default: _withCtx(() => [
                              _hoisted_20,
                              _hoisted_21
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: "c-modal",
          role: "dialog",
          "aria-hidden": !_ctx.modalExpanded
        }, [
          _createElementVNode("div", {
            class: "c-modal__backdrop j-modal-backdrop",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("button", {
                  type: "button",
                  class: "c-modal__close",
                  "aria-label": "このモーダルを閉じる",
                  "data-dismiss": "modal",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_27)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("section", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("ul", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTagTypes('category'), (tag) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: tag.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: { path: `/tag/${tag.type}/${tag.id}` }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("section", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("ul", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTagTypes('stage'), (tag) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: tag.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: { path: `/tag/${tag.type}/${tag.id}` }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("section", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("ul", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTagTypes('tag'), (tag) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: tag.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: { path: `/tag/${tag.type}/${tag.id}` }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                type: "button",
                class: "c-modal__close",
                "data-dismiss": "modal",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, _hoisted_41)
            ])
          ])
        ], 8, _hoisted_22)
      ], 64))
    : (_openBlock(), _createElementBlock("header", _hoisted_42, [
        _createElementVNode("h1", _hoisted_43, [
          _createElementVNode("img", {
            src: _ctx.logologin('pc'),
            alt: "Video Library",
            width: "465",
            height: "44"
          }, null, 8, _hoisted_44)
        ]),
        _hoisted_45
      ]))
}